<template>
  <div>
    <Modal importStyle="App">
      <template #default>
        <div
          :class="`${classVariableName}-mob-gallery-list-container`"
          @scroll="handleScroll"
        >
          <div :class="`${classVariableName}-mob-gallery-details-modal-header`">
            <svg @click="onClose" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <path d="M11.8315 5.88683C12.1237 6.18035 12.1227 6.65522 11.8292 6.94749L7.06555 11.6906H20.2502L20.352 11.6974C20.718 11.7471 21.0002 12.0609 21.0002 12.4406C21.0002 12.8548 20.6644 13.1906 20.2502 13.1906H7.06711L11.8292 17.9336L11.902 18.0176C12.1205 18.3107 12.0971 18.7274 11.8314 18.9942C11.5391 19.2877 11.0643 19.2887 10.7708 18.9964L4.73566 12.9863C4.62807 12.8848 4.55049 12.7518 4.51763 12.6021C4.46428 12.36 4.53201 12.0965 4.72081 11.9085L10.7708 5.88454L10.8551 5.81211C11.1492 5.59489 11.5658 5.61999 11.8315 5.88683Z" fill="#211A1E"/>
            </svg>
            Ratings & Reviews
          </div>
          <div :class="`${classVariableName}-mob-pdp-main-section`">
            <div :class="`${classVariableName}-mob-pdp-main-first`">
              <RatingStatsComponent
                :averageRating="averageRating"
                :totalRatings="totalRatings"
                :ratingStats="ratingStats"
                :maximumRating="maximumRating"
                :verifiedCount="verifiedCount"
              />

              <hr :class="`${classVariableName}-mob-vertical-divider`" />

              <GalleryView
                v-if="
                  imageCount !== 0 &&
                  validationConfig &&
                  !validationConfig.image.hidden
                "
                :validationConfig="validationConfig"
                :userCurrentReview="userCurrentReview"
                :setAlert="(message, type) => toast(message, type)"
                :productId="productId"
                :imageCount="imageCount"
                :product="product"
              />
            </div>

            <div
              v-if="!isEmpty(reviews) || !isEmpty(filters)"
              :class="`${classVariableName}-mob-pdp-listing-box`"
            >
              <Filters
                @updateFilter="(event) => getFilteredReviews(event)"
                :reviewStats="reviewStats"
                :variantStats="variantStats"
                :originDetails="originDetails"
                :is-mobile="true"
              />
              <div
                ref="reviewScrollContainer"
                @scroll="handleScroll"
                style="overflow-y: auto;"
              >
                <ReviewList
                  :product="product"
                  :validationConfig="validationConfig"
                  :userCurrentReview="userCurrentReview"
                  :reviews="reviews"
                  :setAlert="(message, type) => toast(message, type)"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import {
  isEmpty, classVariableName, scrollRequired,
  emitEvent, getEventData
} from "../../utils";
import CUSTOM_EVENTS from "../../constants";
import Modal from "../common/Modal.vue";
import RatingStatsComponent from "../RatingStats.vue";
import GalleryView from "./GalleryView.vue";
import Filters from "../Filters.vue";
import ReviewList from "../ReviewListing.vue";

export default defineComponent({
  name: "reviewDetailsModalComponent",
  components: {
    Modal,
    RatingStatsComponent,
    GalleryView,
    Filters,
    ReviewList,
  },
  props: {
    onClose: Function,
    getNextPage: Function,
    loading: Boolean,
    openImageReviewDetailsModal: Function,

    averageRating: Number,
    totalRatings: Number,
    ratingStats: Object,
    maximumRating: Number,
    verifiedCount: Number,

    validationConfig: Object,
    userCurrentReview: Object,
    setAlert: Function,
    productId: String,
    imageCount: Number,
    product: Object,

    reviewStats: Object,
    variantStats: Object,
    originDetails: Object,
    getFilteredReviews: Function,
    filters: Object,

    reviews: { type: Array, default: [] },
  },
  mounted() {
    this.setVhUnit();
    window.addEventListener('resize', this.setVhUnit);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVhUnit);
  },
  setup() {},
  data() {
    return {
      classVariableName: classVariableName,
    };
  },
  methods: {
    setVhUnit() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    isEmpty(val) {
      return isEmpty(val);
    },
    async handleScroll() {
      const scrollContainer = this.$refs.reviewScrollContainer;
      if (!this.loading && scrollRequired(scrollContainer)) {
        emitEvent(CUSTOM_EVENTS.VIEW_ALL_REVIEWS, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'PDP', this.product, this.userCurrentReview));
        return await this.getNextPage(); // Replace with your function
      }
    },
    async openReviewDetails(review) {
      emitEvent(CUSTOM_EVENTS.REVIEWS_WITH_IMAGES_CLICK_ON_PAGE, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'image_gallery', this.product, null));
      await this.openImageReviewDetailsModal(review);
    },
  },
});
</script>
<style lang="scss" scoped>
@import "../../assets/Mob.scss";
</style>
